module.exports = __webpack_public_path__ + "img/instabank@2x.c20ff89.png";